module.exports = __webpack_public_path__ + "media/images/semen_approval-e966d27979a327aa080fe90568a786a7.png";